import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { TrustStrip } from "../components/TrustStrip";
import { Problem } from "../components/Problem";
import { Method } from "../components/Method";
import { Services } from "../components/Services";
import { WhyUs } from "../components/WhyUs";
import { HowItWorks } from "../components/HowItWorks";
import { Guarantee } from "../components/Guarantee";
import { Packages } from "../components/Packages";
import { ServiceArea } from "../components/ServiceArea";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { StickyMobileCTA } from "../components/StickyMobileCTA";

export default function Home() {
  return (
    <div className="pb-16 md:pb-0" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Problem />
        <Method />
        <Services />
        <WhyUs />
        <HowItWorks />
        <Guarantee />
        <Packages />
        <ServiceArea />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
